var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessenger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "#1E82F0",
  rx: 16
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.313 15.679c0-5.955 4.666-10.366 10.685-10.366s10.686 4.414 10.686 10.368-4.667 10.365-10.686 10.365a11.7 11.7 0 0 1-3.093-.411.86.86 0 0 0-.572.043l-2.121.935a.854.854 0 0 1-1.2-.756l-.058-1.902a.84.84 0 0 0-.286-.61c-2.079-1.859-3.355-4.552-3.355-7.666m7.407-1.948-3.139 4.98c-.302.478.286 1.015.735.673l3.371-2.56a.64.64 0 0 1 .772-.002l2.498 1.873c.75.56 1.82.366 2.319-.428l3.141-4.977c.3-.478-.288-1.018-.737-.676l-3.371 2.56a.64.64 0 0 1-.772.002l-2.498-1.872a1.604 1.604 0 0 0-2.319.427",
  clipRule: "evenodd"
})));
export default SvgMessenger;